import {subtract} from 'stringdate';
import {useCountry} from '~/feature/country/CountryContext';
import useDatePickerMinAndMaxDates from './useDatePickerMinAndMaxDates';

export default function useEarliestSelectableCreativeDate(options?: {type: 'spend' | 'creative'}) {
    const {isCreativeOnTrial} = useCountry();
    const {maxValue, minValue} = useDatePickerMinAndMaxDates({type: options?.type ?? 'creative'});
    const earliestSelectableDate = isCreativeOnTrial ? subtract('P1M')(maxValue) : minValue;
    return earliestSelectableDate;
}
